import { render, staticRenderFns } from "./CriarMonit.vue?vue&type=template&id=665d9249"
import script from "./CriarMonit.vue?vue&type=script&lang=js"
export * from "./CriarMonit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports